import {
ErrorModel
} from 'one-state-subjecterror/src/ErrorModel';

import {
    Action
} from 'one-state';

import {
SET,
REINIT
} from './types';

/**
 * Redux action creator to set the list
 * of calling destination
 * @param errorinfo has data of patientlookup error
 * @returns action instance
 */
export const setAction = (errorinfo: ErrorModel ):
Action<typeof SET,ErrorModel> => ({
    type: SET,
    payload: errorinfo,
});

/**
 * Re-initialize the state
 * @returns action instance
 */

export const reinitAction = ():
Action<typeof REINIT> => ({
    type: REINIT,
});

/**
 * List of all valid actions
 */
export type Actions = 
    ReturnType<typeof setAction> |
    ReturnType<typeof reinitAction>;